module.exports = __webpack_public_path__ + "img/slider_3_srb_mob.4804929e.jpg";